export enum FeeCalculationTypes {
    FlatPerGallon = 0,
    Percentage = 1,
    // Obsolete
    PercentageOfTotal = 2,
}

export enum DiscountType {
    FlatPerGallon = 0,
    Percentage = 1,
}
